module.exports = __webpack_public_path__ + "static/f_logo-63af7a3d02aa40d059a720d737a26fc4.png";